/* istanbul ignore file */
const styles = ({ palette: { text }, spacing: { unit } }) => ({
  bankDropDown: {
    '& .flex-dropdown': {
      position: 'relative',
      margin: 0
    },
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    float: 'left'
  },
  area: {
    width: '100%'
  },
  align: {
    '&.gutters, & + $addresses': {
      margin: [0, -(unit * 2)]
    }
  },

  row: {
    display: 'flex',
    margin: [0, -(unit * 2)]
  },
  typeofBankCodes: {
    marginBottom: unit * 2
  },
  bankDropDownInline: {
    display: 'flex',
    flexDirection: 'column',
    padding: [0, unit * 2],

    '& + .international': {
      marginTop: 30,
      marginLeft: 0
    },

    '& .flex-dropdown': {
      position: 'relative'
    }
  },
  addresses: {
    marginTop: unit,
    display: 'flex',
    flexDirection: 'column',
    '&[class*=col-]': {
      padding: 0
    },
    '& span': {
      fontSize: unit * 1.5,
      color: text.dark,
      textTransform: 'uppercase'
    }
  },
  resetMargins: {
    '& label[for*=-select-field]': {
      margin: 0
    }
  }
});

export default styles;
